/** Outdoor GPS sessions: run, walk, hike — same map flow, different save labels. */

export type GpsActivityKind = 'run' | 'walk' | 'hike';

export const GPS_CARDIO_EXERCISE_NAMES = ['Running', 'Walking', 'Hiking'] as const;
export type GpsCardioExerciseName = (typeof GPS_CARDIO_EXERCISE_NAMES)[number];

export function isGpsCardioWorkoutType(workoutType: string | null | undefined): boolean {
  const w = (workoutType || '').toLowerCase();
  return w === 'running' || w === 'walking' || w === 'hiking';
}

export function findGpsCardioExercise<T extends { name: string }>(
  exercises: T[] | undefined | null
): T | undefined {
  if (!exercises?.length) return undefined;
  return exercises.find((e) =>
    GPS_CARDIO_EXERCISE_NAMES.includes(e.name as GpsCardioExerciseName)
  );
}

/** Picker id from Workouts navigation state */
export function gpsActivityKindFromNavState(raw: unknown): GpsActivityKind {
  if (raw === 'walking') return 'walk';
  if (raw === 'hiking') return 'hike';
  return 'run';
}

export function exerciseNameForGpsActivity(kind: GpsActivityKind): GpsCardioExerciseName {
  if (kind === 'walk') return 'Walking';
  if (kind === 'hike') return 'Hiking';
  return 'Running';
}

/** Persist lowercase so Progress / Exercise History match `isGpsCardioWorkoutType`. */
export function workoutTypeForGpsActivity(kind: GpsActivityKind): string {
  if (kind === 'walk') return 'walking';
  if (kind === 'hike') return 'hiking';
  return 'running';
}

/** DB `workout_type` string → primary exercise row name */
export function exerciseNameFromWorkoutType(workoutType: string | undefined | null): GpsCardioExerciseName {
  const w = (workoutType || '').toLowerCase();
  if (w === 'walking') return 'Walking';
  if (w === 'hiking') return 'Hiking';
  return 'Running';
}
